module.exports = __webpack_public_path__ + "img/remove.62b78eaa.png";